import React from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { formatDate2, formatPrice } from '../../../../utils/utils';
import CartItem from './cart-item.component';
import useCart from '../../../../hooks/useCart';
import SwitchCart from '../../../switch-cart/switch-cart.component';
import { CART_TABS } from '../../../../utils/constants';
import MedCartItem from './med-cart-item.component';

const ConfirmOrder = ({closeCart}) => {
    const navigate = useNavigate();
    const { cart, tab } = useCart();

    const closeDrawer = () => {
        closeCart();
    };

    const handleConfirm = () => {
        navigate('/place-order');
        closeDrawer();
    };

    const cartContent = () => {
        if (cart.length < 1) {
            return <div className='empty-cart-container'>Cart is empty</div>;
        }

        const cartItemsSwitcher = () => {
            if (tab === CART_TABS.MEDS) {
                return cart.map((cartItem) => <MedCartItem key={cartItem.id} {...cartItem} />);
            }

            return cart.map((cartItem, i) => <CartItem key={cartItem.id} {...cartItem} itemIndex={i} />);
        };
        const cartItems = cartItemsSwitcher();
        const cartPrice = cart.reduce((acc, curr) => +curr.price + acc, 0);
        const cartTotals = (
            <div className='cart-totals-container'>
                <div className='flex-gap'>
                    <Typography variant='h6'>Cart Totals:</Typography>
                    <Typography variant="h6">{formatPrice(cartPrice)}</Typography>
                </div>
            </div>
        );
        const aboutCartItems = tab === CART_TABS.MEDS ? 'Medicines' : 'Pathology Lab test';

        return (
            <div className='confirm-order-container'>
                <Box className="space-between">
                    <Typography variant="h6">Service Information</Typography>
                    <div>Date: {formatDate2(new Date())}</div>
                </Box>
                <Typography variant="h6">{aboutCartItems}</Typography>
                {cartItems}
                <Divider />
                {cartTotals}
            </div>
        );
    };

    const confirmBtn = cart.length > 0 && (
        <div className='cart-step-actions'>
            <Button variant='contained' className='small-brown-btn' onClick={handleConfirm}>Confirm</Button>
        </div>
    );

    return (
        <Box className="cart-drawer-container">
            <div className='space-between'>
                <Typography className='ext-large-brown-txt' style={{textAlign: 'left'}}> My Cart </Typography>
                <CloseIcon onClick={closeDrawer} />
            </div>
            <SwitchCart />
            {cartContent()}
            {confirmBtn}
        </Box>
    );
};

export default ConfirmOrder;
ConfirmOrder.propTypes = {
    closeCart: PropTypes.func.isRequired
};